import {Component, EventEmitter, ViewChild, ElementRef, OnInit, Output} from '@angular/core';

import {FormsModule} from '@angular/forms';
import {HttpClient} from '@angular/common/http';
import {NlrFieldRecordAttachmentsModalDataService} from './field-record-attachments-modalData.service';
import {PlanPdfService} from '../../common/service/plan-pdf.service';
import {AppConfigService} from '../../common/service/app-config.service';

@Component({
    selector: 'nlr-field-record-attachments-modal',
    imports: [FormsModule],
    templateUrl: './field-record-attachments-modal.component.html',
    styleUrls: ['./field-record-attachments-modal.scss', '../../common/component/modal/modal.scss']
})
export class NlrFieldRecordAttachmentsModal implements OnInit {
    fileToUpload = undefined;
    maxSizeBytes = undefined;
    extensions = undefined;
    prefix = undefined;
    isNotLandgateSigned = undefined;
    checkPdfSignature = undefined;
    isPdfManual = undefined;
    attachments = undefined;
    index = undefined;

    @ViewChild('uploadFileInput', {static: false}) uploadFileInput: ElementRef;
    @Output() modalCloseEvent = new EventEmitter<void>();

    constructor(
        private nlrFieldRecordAttachmentsModalDataService: NlrFieldRecordAttachmentsModalDataService,
        private planPdfService: PlanPdfService,
        private http: HttpClient,
        private appConfigService: AppConfigService
    ) {}

    ngOnInit(): void {
        this.nlrFieldRecordAttachmentsModalDataService.getAttachmentsData().subscribe(data => {
            this.maxSizeBytes = data.maxSize;
            this.extensions = data.extensions;
            this.prefix = data.prefix;
            this.checkPdfSignature = data.checkPdfSignature;
            this.attachments = data.attachments;
            this.index = data.index;
        });
    }

    dismissModal() {
        this.modalCloseEvent.emit();
    }

    validateAndUpload() {
        if (this.maxSizeBytes && this.fileToUpload.size > this.maxSizeBytes) {
            var errorMsg =
                'The size (' + this.fileToUpload.size + "B) of '" + this.fileToUpload.name + "' exceeds the maximum (" + this.maxSizeBytes + 'B)';
            //alertModalService.createAlertMessage(errorMsg);
        }

        let fileReader = new FileReader();
        this.isPdfManual = false;
        if (this.isValidSuffix(this.fileToUpload.name)) {
            const fileName = this.fileToUpload.name.toLowerCase();
            const fileNameExtension = this.getFileSuffix(fileName).toLocaleLowerCase();
            const fileNameBaseTruncated = fileName.slice(0, Math.min(1024, fileName.length) - fileNameExtension.length);
            const fileNameTruncatedEncoded = encodeURIComponent(fileNameBaseTruncated + fileNameExtension);

            fileReader.readAsArrayBuffer(this.fileToUpload);
            fileReader.onload = event => {
                const result = event.target.result;
                const url = this.appConfigService.settings.apiGatewayUrl + '/attachment/signedUrl/' + this.prefix + '/' + fileNameTruncatedEncoded;
                this.http.get<any>(url).subscribe({
                    next: url => {
                        if (fileNameExtension === '.pdf') {
                            this.isNotLandgateSigned = true;
                            if (this.checkPdfSignature) {
                                this.uploadPlanPdfAttachment(url, this.toArrayBuffer(result));
                            }
                        }
                    },
                    error: error => {
                        console.error('Error getting url: ' + error);
                        //alertModalService.createAlertMessage("System error getting signed url.");
                    }
                });
            };
        } else {
            this.uploadFile({});
        }
    }

    uploadFileChange(files: any) {
        this.fileToUpload = files[0];
    }

    isValidSuffix(fileName: string) {
        const upperCaseExtensions = this.extensions.map(value => {
            return value.toUpperCase();
        });

        return upperCaseExtensions.indexOf(this.getFileSuffix(fileName)) != -1;
    }

    getFileSuffix(filename: string) {
        if (filename === undefined) {
            return '';
        }
        const lastIndexOfDot = filename.lastIndexOf('.');

        if (lastIndexOfDot == -1) {
            return '';
        }

        return filename.slice(lastIndexOfDot).toUpperCase();
    }

    uploadPlanPdfAttachment(url: string | undefined, result: ArrayBuffer) {
        this.planPdfService.isLandgateSigned(this.arrayBufferToBase64(result)).subscribe({
            next: signed => {
                if (!signed) {
                    //To-Do: Call confirmation modal
                } else {
                    this.isNotLandgateSigned = false;
                    this.uploadFile(url);
                }
            }
        });
    }

    uploadFile(fileData: any) {
        const fileNamesArray = [];

        if (this.attachments !== undefined && this.attachments.length > 0) {
            for (var i = 0; i < this.attachments.length; ++i) {
                if (this.attachments[i].fileName !== undefined) {
                    fileNamesArray.push(this.attachments[i].fileName);
                }
            }
        }
        let fileReader = new FileReader();
        fileReader.onload = event => {
            if (fileData) {
                const fileContent = event.target.result;
                const xhr = new XMLHttpRequest();

                if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                        this.nlrFieldRecordAttachmentsModalDataService.updateAttachment(this.index, {
                            fileName: this.fileToUpload.name,
                            fileSize: this.fileToUpload.size,
                            url: fileData.url,
                            uuid: fileData.uuid
                        });
                    } else {
                        //alertModalService.createAlertMessage("The file did not save. Please try again. If the problem persists contact the Customer Services.");
                    }
                }

                xhr.open('PUT', fileData.url, true);
                xhr.setRequestHeader('Content-Type', 'application/octet-stream');
                xhr.setRequestHeader('x-amz-server-side-encryption', 'AES256');
                xhr.send(fileContent);
                this.modalCloseEvent.emit();
            } else {
                const url = this.appConfigService.settings.apiGatewayUrl + '/attachment/signedUrl/' + this.prefix;
                this.http.get<any>(url).subscribe({
                    next: data => {
                        console.log(data);
                        const xhr = new XMLHttpRequest();
                        const fileContent = event.target.result;
                        console.log(fileContent);

                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) {
                                this.nlrFieldRecordAttachmentsModalDataService.updateAttachment(this.index, {
                                    fileName: this.fileToUpload.name,
                                    fileSize: this.fileToUpload.size,
                                    url: fileData.url,
                                    uuid: fileData.uuid
                                });
                            } else {
                                //alertModalService.createAlertMessage("The file did not save. Please try again. If the problem persists contact the Customer Services.");
                            }
                        }

                        xhr.open('PUT', fileData.url, true);
                        xhr.setRequestHeader('Content-Type', 'application/octet-stream');
                        xhr.setRequestHeader('x-amz-server-side-encryption', 'AES256');
                        xhr.send(fileContent);
                        this.modalCloseEvent.emit();
                    },

                    error: error => {
                        console.error('Error getting url: ' + error);
                        const errorMessage = 'System error getting signed url.';
                        //alertModalService.createAlertMessage(errorMessage);
                    }
                });
            }
        };
        fileReader.readAsArrayBuffer(this.fileToUpload);
    }

    arrayBufferToBase64(buffer: ArrayBuffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    toArrayBuffer(input: string | ArrayBuffer): ArrayBuffer {
        if (typeof input === 'string') {
            const encoder = new TextEncoder();
            return encoder.encode(input).buffer;
        } else if (input instanceof ArrayBuffer) {
            return input;
        } else {
            throw new TypeError('Input must be a string or an ArrayBuffer');
        }
    }

    clickFileInput() {
        this.uploadFileInput.nativeElement.click();
    }
}
